import Swiper from 'swiper';
import { Navigation, Pagination} from 'swiper/modules';
Swiper.use([Navigation, Pagination]);

function setMaxHeight(): void { 

  const containers = document.querySelectorAll<HTMLElement>(".news-list-view");

  containers.forEach((container) => {

    const headers = container.querySelectorAll<HTMLElement>(".header");
  
    if (headers.length === 0) return;

    headers.forEach(h => {
      h.style.height = "";
    });

    let tallest = 0;
    headers.forEach((h, i) => {
      const hgt = Math.ceil(h.scrollHeight);
      // console.log(`  header[${i}] scrollHeight=${hgt}px`);
      if (hgt > tallest) tallest = hgt;
    });

    const maxH = tallest; 

    headers.forEach((h, i) => {
      h.style.height = `${maxH}px`;
      // sanity check:
      // console.log(`  applied to header[${i}] ->`, h.style.maxHeight);
    });

  });
}

function setMaxHeight2(): void {
  const containers = document.querySelectorAll<HTMLElement>('[slider]');

  containers.forEach((container) => {
    const articles = container.querySelectorAll<HTMLElement>('.article.header-slider');

    if (articles.length === 0) return;

    articles.forEach((article) => {
      article.style.height = '';
    });

    let tallest = 0;

    articles.forEach((article) => {
      const height = Math.ceil(article.scrollHeight);
      if (height > tallest) tallest = height;
    });

    articles.forEach((article) => {
      article.style.height = `${tallest}px`;
    });
  });
}


window.addEventListener("load", () => {
  // run again after layout settles
  requestAnimationFrame(() => setMaxHeight());
  setMaxHeight2(); 
});

window.addEventListener("resize", () => {  
  setMaxHeight();
  setMaxHeight2(); 
});

// Copy news title to hero element on detail page:
const newstitleEl = document.getElementById('header-title');
if (newstitleEl) {
  const newstitle = newstitleEl.textContent;
  const heroHeadlineEl = document.querySelector('[data-ctype="iu_hero"] .js-hero-headline');
  if (heroHeadlineEl) {
    heroHeadlineEl.textContent = newstitle;
  }
}

// Collapsible-News

document.addEventListener("DOMContentLoaded", () => {
    const blocks = document.querySelectorAll<HTMLElement>(".collapsible-news .toggle-block");  
    
    blocks.forEach(block => {
        const toggleButton = block.querySelector<HTMLElement>(".toggle-button");        

        toggleButton?.addEventListener("click", () => {
            // Toggle open/closed state         
           
            if (block.dataset.state === "open") {
                block.dataset.state = "closed";
                
            } else {
                block.dataset.state = "open";                
            }
        });
    });
});

// Magazin-slider

export function initMagazinSwiper(): void {
  const swiperElements = document.querySelectorAll<HTMLElement>('.magazin-item-slider');

  swiperElements.forEach((swiperElement) => {
    const prevButton = swiperElement.querySelector<HTMLElement>('.swiper-button-prev');
    const nextButton = swiperElement.querySelector<HTMLElement>('.swiper-button-next');

    if (!prevButton || !nextButton) return;

    const mediaCount = Number(swiperElement.dataset.mediaCount ?? 0);

    var slidesPerViewWide = 2;

    if( mediaCount >= 4 ) {
      slidesPerViewWide = 3;
    }

    new Swiper(swiperElement, {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 24,
      centeredSlides: true,
      loop: true,

      navigation: {
        prevEl: prevButton,
        nextEl: nextButton,
      },

      breakpoints: {
        768: {
          slidesPerView: 2,
          centeredSlides: false,
        },
        1024: {
          slidesPerView: slidesPerViewWide,
          centeredSlides: false,
        },
      },
    });
  });
}

// Fire on DOM ready and on full load (helps if fonts/images affect height)
document.addEventListener("DOMContentLoaded", () => {  
  setMaxHeight();  
  initMagazinSwiper();
});

